import axios from 'axios'

export default defineNuxtPlugin(nuxtApp => {
  const config = useAppConfig()

  const httpInstance = axios.create({
    baseURL: config.appConfig.apiBaseUrl, // 使用运行时配置
    timeout: 10000
  })

  // 请求拦截器
  httpInstance.interceptors.request.use(
    async config => {
      return config
    },
    e => Promise.reject(e)
  )

  // 响应拦截器
  httpInstance.interceptors.response.use(
    async res => {
      if (res.data.error_code === 0) {
        return Promise.resolve(res.data)
      } else if (res.data.error_code === 41001) {
        // 用户登录失效 移除token
        // const userStore = useUserStore();
        // userStore.logout();
        // const nativeInteropHelper = await getWV2();
        // nativeInteropHelper.Logout(res.data.error_message);
        return Promise.reject(res.data.error_message)
      } else if (res.data.error_code === 41907) {
        // 用户逗币不足
        return Promise.reject(res.data)
      } else if (res.data.error_code === 41912) {
        // 用户逗钻不足
        return Promise.reject(res.data)
      } else {
        // ElMessage.error(res.data.error_message);
        return Promise.reject(res.data.error_message)
      }
    },
    e => {
      console.log(e)
      // 统一错误提示
      //   ElMessage({
      //     type: "warning",
      //     message: e.message,
      //   });
      return Promise.reject(e)
    }
  )

  // 将 axios 实例添加到 Nuxt 应用实例中
  nuxtApp.provide('axios', httpInstance)
})
